<template>
    <v-alert
        v-if="shouldShowAlert"
        :value="true"
        type="warning"
        border="left"
        colored-border
        elevation="2"
        class="mb-3"
    >
        <div class="d-flex align-center">
            <v-icon left color="warning">mdi-alert</v-icon>
            <div class="flex-grow-1">
                <div class="font-weight-bold">{{ title }}</div>
                <div class="body-2">
                    {{ message }}
                </div>
                <div v-if="gapsData && gapsData.gaps && gapsData.gaps.length > 0" class="mt-2 caption">
                    <span class="font-weight-bold">Numeri mancanti:</span>
                    <span v-if="gapsData.gaps.length <= 10">{{ formatGaps(gapsData.gaps) }}</span>
                    <span v-else>
                        {{ formatGaps(gapsData.gaps.slice(0, 10)) }}
                        <span class="grey--text">e altri {{ gapsData.gaps.length - 10 }}...</span>
                    </span>
                </div>
            </div>
            <v-btn
                v-if="showDetails"
                text
                small
                color="warning"
                @click="$emit('show-details')"
            >
                Dettagli
            </v-btn>
        </div>
    </v-alert>
</template>

<script>
export default {
    name: 'NumberingGapsAlert',

    props: {
        modelType: {
            type: String,
            required: true
        },
        sectionalId: {
            type: Number,
            required: true
        },
        sectionalName: {
            type: String,
            default: null
        },
        year: {
            type: Number,
            default: () => new Date().getFullYear()
        },
        showDetails: {
            type: Boolean,
            default: false
        },
        customTitle: {
            type: String,
            default: null
        },
        customMessage: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            gapsData: null,
            loading: false
        }
    },

    computed: {
        shouldShowAlert() {
            return this.gapsData &&
                   this.gapsData.enabled !== false &&
                   this.gapsData.total_missing > 0
        },

        title() {
            if (this.customTitle) return this.customTitle
            return 'Attenzione: rilevati salti di numerazione'
        },

        message() {
            if (this.customMessage) return this.customMessage

            if (!this.gapsData) return ''

            const count = this.gapsData.total_missing
            const range = this.gapsData.range

            // Use sectional name from gaps response or from prop
            const sectionalName = this.gapsData.sectional_name || this.sectionalName

            // Costruisci il contesto (sezionale + anno)
            let context = ''
            if (sectionalName && this.year) {
                context = ` per il sezionale "${sectionalName}" nell'anno ${this.year}`
            } else if (sectionalName) {
                context = ` per il sezionale "${sectionalName}"`
            } else if (this.year) {
                context = ` nell'anno ${this.year}`
            }

            if (count === 1) {
                return `È stato rilevato 1 numero mancante nell'intervallo ${range}${context}.`
            } else {
                return `Sono stati rilevati ${count} numeri mancanti nell'intervallo ${range}${context}.`
            }
        }
    },

    watch: {
        modelType: 'fetchGaps',
        sectionalId: 'fetchGaps',
        year: 'fetchGaps'
    },

    mounted() {
        this.fetchGaps()
    },

    methods: {
        async fetchGaps() {
            if (!this.modelType || !this.sectionalId) return

            this.loading = true

            try {
                const data = await this.$store.dispatch('FETCH_GAPS', {
                    modelType: this.modelType,
                    sectionalId: this.sectionalId,
                    year: this.year
                })

                this.gapsData = data
            } catch (error) {
                console.error('Error fetching gaps:', error)
                this.gapsData = null
            } finally {
                this.loading = false
            }
        },

        formatGaps(gaps) {
            if (!gaps || gaps.length === 0) return ''

            // Group consecutive numbers
            const groups = []
            let start = gaps[0]
            let end = gaps[0]

            for (let i = 1; i < gaps.length; i++) {
                if (gaps[i] === end + 1) {
                    end = gaps[i]
                } else {
                    if (start === end) {
                        groups.push(start.toString())
                    } else {
                        groups.push(`${start}-${end}`)
                    }
                    start = gaps[i]
                    end = gaps[i]
                }
            }

            // Add last group
            if (start === end) {
                groups.push(start.toString())
            } else {
                groups.push(`${start}-${end}`)
            }

            return groups.join(', ')
        },

        refresh() {
            this.fetchGaps()
        }
    }
}
</script>

<style scoped>
.v-alert {
    border-radius: 4px;
}
</style>
